import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, personalInfo, REQUIRED } from "./utils";
import { getDescription } from "../../utils";
import * as URUGUAY from "../../onboarding/profile-info/form/uy/constants.uy";

export const uruguayFields = {
  uyCid: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "uyCid",
    label: "Identification Number (Cédula de Identidad)",
    validations: REQUIRED,
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("UY"),
    },
    value: personalInfo("uyCid", ""),
  }),
  uySeguroDeSaludBps: field({
    type: FieldTypes.select,
    informationType: "benefits",
    name: "uySeguroDeSaludBps",
    label: "Seguro de Salud BPS",
    validations: REQUIRED,
    placeholder: "Select Seguro de Salud BPS",
    options: URUGUAY.uySeguroDeSaludBpsOptions,
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("UY"),
    },
    value: personalInfo("uySeguroDeSaludBps", ""),
    format: (value) =>
      getDescription(URUGUAY.uySeguroDeSaludBpsOptions, value) ?? value,
  }),
};
